
namespace TabAurous.Reports {
    
    @Serenity.Decorators.registerClass()
    export class PurchaseReturnGrid extends Serenity.EntityGrid<TabAurous.Purchase.PurchaseReturnMasterRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseReturnMaster'; }
        protected getDialogType() { return TabAurous.Purchase.PurchaseReturnMasterDialog; }
        protected getIdProperty() { return TabAurous.Purchase.PurchaseReturnMasterRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Purchase.PurchaseReturnMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Purchase.PurchaseReturnMasterRow.localTextPrefix; }
        protected getService() { return TabAurous.Purchase.PurchaseReturnMasterService.baseUrl; }
        private chartContainer: JQuery;
        private chartPanel: LineChartPanel;
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters(); 

            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: TabAurous.Purchase.PurchaseReturnMasterService.baseUrl+'/PartyList',
                    idField: "LedgerName",
                    textField: "LedgerName",
                    multiple: true
                },
                field: 'PartyId',
                title: 'Vendor',
                handler: w => {
                    var temp = [];
                    if (w.value != null && w.value.length > 0) {
                        var values = w.value;
                        for (var i = 0; i < values.length; i++) {
                            temp.push((values[i]));
                        } if (temp.length != 0) {
                            (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                        }
                    } else
                        (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                },

                cssClass: 'hidden-xs'
            });

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp= [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },
                
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            }); 
          

            return filters;
        }
        onViewProcessData(response: Serenity.ListResponse<TabAurous.Purchase.PurchaseReturnMasterRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new LineChartPanel(this.chartContainer, { items: response.Entities });
             
            return response;
        }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {
                    
            //        Common.ReportHelper.execute({
            //            reportKey: 'Reports.PurchaseReturnRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date:this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "Purchase Return",
                onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }
    }
}